import { BaseService } from '@/core/base-service';
import axios from 'axios';

export default class StateService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/state');
  }

  public getOptions(): Promise<any> {
    return axios.get(this.endpointName + '/combobox');
  }
}
